var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<i class=\"fa fa-sort-asc\" ng-show=\"currentOrder === newOrder && reverseOrder\" aria-hidden=\"true\"></i>\n<i class=\"fa fa-sort-desc\" ng-show=\"currentOrder === newOrder && !reverseOrder\" aria-hidden=\"true\"></i>\n<i class=\"fa fa-sort\" ng-show=\"currentOrder !== newOrder\" aria-hidden=\"true\"></i>\n";
var id1="app/_directives/pkp-sort-state.directive.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;